import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { user_type, logo_text, logo } from "../../config";

const LeftSidebar = () => {
  const navigate = useNavigate();
  const [admin, setAdmin] = useState(false);
  const [tpt, setTpt] = useState(false);
  const [teacher, setTeacher] = useState(false);

  useEffect(() => {
    if (user_type === "teacher") {
      setAdmin(false);
      setTpt(false);
      setTeacher(true);
    } else if (user_type === "admin") {
      setTpt(false);
      setTeacher(false);
      setAdmin(true);
    } else if (user_type === "TPT") {
      setAdmin(false);
      setTeacher(false);
      setTpt(true);
    }
  }, [user_type]);

  return (
    <>
      <aside
        id="layout-menu"
        className="layout-menu menu-vertical menu bg-menu-theme"
      >
        <div className="app-brand demo ">
          <a onClick={() => navigate("/home")} className="app-brand-link">
            <span className="app-brand-logo demo">
              <img className="h-8" src={logo} />
            </span>
            <span className="app-brand-text demo menu-text fw-bold ">
              <img className="h-8" src={logo_text} />
            </span>
          </a>
          <a className="layout-menu-toggle menu-link text-large ms-auto">
            <svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.4854 4.88844C11.0081 4.41121 10.2344 4.41121 9.75715 4.88844L4.51028 10.1353C4.03297 10.6126 4.03297 11.3865 4.51028 11.8638L9.75715 17.1107C10.2344 17.5879 11.0081 17.5879 11.4854 17.1107C11.9626 16.6334 11.9626 15.8597 11.4854 15.3824L7.96672 11.8638C7.48942 11.3865 7.48942 10.6126 7.96672 10.1353L11.4854 6.61667C11.9626 6.13943 11.9626 5.36568 11.4854 4.88844Z"
                fill="currentColor"
                fillOpacity="0.6"
              />
              <path
                d="M15.8683 4.88844L10.6214 10.1353C10.1441 10.6126 10.1441 11.3865 10.6214 11.8638L15.8683 17.1107C16.3455 17.5879 17.1192 17.5879 17.5965 17.1107C18.0737 16.6334 18.0737 15.8597 17.5965 15.3824L14.0778 11.8638C13.6005 11.3865 13.6005 10.6126 14.0778 10.1353L17.5965 6.61667C18.0737 6.13943 18.0737 5.36568 17.5965 4.88844C17.1192 4.41121 16.3455 4.41121 15.8683 4.88844Z"
                fill="currentColor"
                fillOpacity="0.38"
              />
            </svg>
          </a>
        </div>
        <div className="menu-inner-shadow"></div>
        <ul className="menu-inner py-1">
          {/* Manage Media */}
          {(admin || teacher || tpt) && (
            <li className=" menu-item ">
              <a className="menu-link menu-toggle waves-effect">
                <i className="menu-icon tf-icons mdi mdi-folder"></i>
                <div data-i18n="Manage Media">Manage Media</div>
                {/* <div className="badge bg-primary rounded-pill ms-auto">5</div> */}
              </a>
              <ul className="menu-sub">
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/addmedia");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="Add Media">Add Media</div>
                  </a>
                </li>
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/viewmedia");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="View Media">View Media</div>
                  </a>
                </li>
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/mediabin");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="Bin">Bin</div>
                  </a>
                </li>
              </ul>
            </li>
          )}

          {/* Manage Class */}
          {admin && (
            <li className=" menu-item">
              <a className="menu-link menu-toggle">
                <i className="menu-icon tf-icons mdi  mdi-presentation"></i>
                <div data-i18n="Manage Class">Manage Class</div>
              </a>
              <ul className="menu-sub">
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/addclass");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="Add Class">Add Class</div>
                  </a>
                </li>
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/viewclass");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="View Classes">View Classes</div>
                  </a>
                </li>
              </ul>
            </li>
          )}

          {/* Manage section */}
          {admin && (
            <li className=" menu-item">
              <a className="menu-link menu-toggle">
                <i className="menu-icon tf-icons mdi mdi-domain"></i>
                <div data-i18n="Manage Section">Manage Section</div>
              </a>
              <ul className="menu-sub">
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/addsection");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="Add Section">Add Section</div>
                  </a>
                </li>
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/viewsection");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="View Sections">View Sections</div>
                  </a>
                </li>
              </ul>
            </li>
          )}

          {/* Manage Subject */}
          {admin && (
            <li className=" menu-item">
              <a className="menu-link menu-toggle">
                <i className="menu-icon tf-icons mdi  mdi-clipboard-text"></i>
                <div data-i18n="Manage Subject">Manage Subject</div>
              </a>
              <ul className="menu-sub">
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/addsubject");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="Add Subject">Add Subject</div>
                  </a>
                </li>
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/viewsubjects");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="View Subjects">View Subjects</div>
                  </a>
                </li>
              </ul>
            </li>
          )}

          {/* Manage Teachers */}
          {admin && (
            <li className=" menu-item">
              <a className="menu-link menu-toggle">
                <i className="menu-icon tf-icons mdi mdi-school"></i>
                <div data-i18n="Manage Teacher">Manage Teacher</div>
              </a>
              <ul className="menu-sub">
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/addteacher");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="Add Teacher">Add Teacher</div>
                  </a>
                </li>
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/viewteachers");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="View Teachers">View Teachers</div>
                  </a>
                </li>
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/tcrforaprvl");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="Teacher For Approval">
                      Teacher For Approval
                    </div>
                  </a>
                </li>
              </ul>
            </li>
          )}

          {/* Manage Student */}
          {admin && (
            <li className=" menu-item">
              <a className="menu-link menu-toggle">
                <i className="menu-icon tf-icons mdi mdi-account-group "></i>
                <div data-i18n="Manage Student">Manage Student</div>
              </a>
              <ul className="menu-sub">
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/addstudent");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="Add Student">Add Student</div>
                  </a>
                </li>
              </ul>
              <ul className="menu-sub">
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/viewstudents");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="View Students">View Students</div>
                  </a>
                </li>
              </ul>
              <ul className="menu-sub">
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/logintracks");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="Login tracks">Login Tracks</div>
                  </a>
                </li>
              </ul>
            </li>
          )}

          {/* Manage Course */}
          {(admin || teacher || tpt) && (
            <li className=" menu-item">
              <a className="menu-link menu-toggle">
                <i className="menu-icon tf-icons mdi mdi-book"></i>
                <div data-i18n="Manage Course">Manage Course</div>
              </a>
              <ul className="menu-sub">
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/addcourse");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="Add Course">Add Course</div>
                  </a>
                </li>
              </ul>
              <ul className="menu-sub">
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/viewcourses");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="View Courses">View Courses</div>
                  </a>
                </li>
              </ul>
              <ul className="menu-sub">
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/coursesforapproval");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="Courses For Approval">
                      Courses For Approval
                    </div>
                  </a>
                </li>
              </ul>
            </li>
          )}

          {/* Manage Plan */}
          {/* <li className=" menu-item">
            <a className="menu-link menu-toggle">
              <i className="menu-icon tf-icons mdi mdi-creation"></i>
              <div data-i18n="Manage Plan">Manage Plan</div>
            </a>
            <ul className="menu-sub">
              <li className="cursor-pointer menu-item">
                <a
                  onClick={() => {
                    navigate("/addplan");
                  }}
                  className="menu-link"
                >
                  <div data-i18n="Add Plan">Add Plan</div>
                </a>
              </li>
            </ul>
          </li> */}

          {/* Manage Assignment */}
          {(admin || teacher || tpt) && (
            <li className=" menu-item">
              <a
                className="menu-link"
                onClick={() => {
                  navigate("/viewpurchase");
                }}
              >
                <i className="menu-icon tf-icons mdi mdi-cart"></i>
                <div data-i18n="View Purchase Courses">
                  View Purchase Courses
                </div>
              </a>
            </li>
          )}
          {(admin || teacher || tpt) && (
            <li className=" menu-item">
              <a
                className="menu-link"
                onClick={() => {
                  navigate("/viewpurchaselist");
                }}
              >
                <i className="menu-icon tf-icons mdi mdi-clipboard-text"></i> 
                <div data-i18n="View Orders">
                  View Orders
                </div>
              </a>
            </li>
          )}
          {(admin || teacher || tpt) && (
            <li className=" menu-item">
              <a className="menu-link menu-toggle">
                <i className="menu-icon tf-icons mdi mdi-file-document"></i>
                <div data-i18n="Manage Assignment">Manage Assignment</div>
              </a>
              <ul className="menu-sub">
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/addassignmentque");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="Add Assignment">Add Assignment</div>
                  </a>
                </li>
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/viewassignments");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="View Assignments">View Assignments</div>
                  </a>
                </li>
              </ul>
            </li>
          )}

          {/* Manage Chapter */}
          {(admin || teacher || tpt) && (
            <li className=" menu-item">
              <a className="menu-link menu-toggle">
                <i className="menu-icon tf-icons mdi mdi-book-open-variant"></i>
                <div data-i18n="Manage Chapter">Manage Chapter</div>
              </a>
              <ul className="menu-sub">
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/addchapter");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="Add Chapter">Add Chapter</div>
                  </a>
                </li>
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/viewchapters");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="View Chapters">View Chapters</div>
                  </a>
                </li>
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/chapterbin");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="Chapter Bin"> Chapter Bin</div>
                  </a>
                </li>
              </ul>
            </li>
          )}

          {/* Manage MCQ */}
          {(admin || teacher || tpt) && (
            <li className=" menu-item">
              <a className="menu-link menu-toggle">
                <i className="menu-icon tf-icons mdi mdi-pencil"></i>
                <div data-i18n="Manage MCQ">Manage MCQ</div>
              </a>
              <ul className="menu-sub">
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/addmcq?type=mcq");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="Add / View MCQ">Add / View MCQ</div>
                  </a>
                </li>
              </ul>
              <ul className="menu-sub">
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/addmcqbank");
                      window.location.reload(false);
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="Add MCQ Bank">Add MCQ Bank</div>
                  </a>
                </li>
              </ul>
              <ul className="menu-sub">
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/viewmcqbank");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="View MCQ Bank">View MCQ Bank</div>
                  </a>
                </li>
              </ul>
            </li>
          )}

          {/* Manage Exam */}
          {(admin || teacher || tpt) && (
            <li className=" menu-item">
              <a className="menu-link menu-toggle">
                <i className="menu-icon tf-icons mdi mdi-book-multiple"></i>
                <div data-i18n="Manage Exam">Manage Exam</div>
              </a>
              <ul className="menu-sub">
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/addexammcq?type=exam");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="Add Exam MCQ">Add Exam MCQ</div>
                  </a>
                </li>
              </ul>
              <ul className="menu-sub">
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/addexam");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="Add Exam">Add Exam</div>
                  </a>
                </li>
              </ul>
              <ul className="menu-sub">
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/viewexams");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="View Exams">View Exams</div>
                  </a>
                </li>
              </ul>
            </li>
          )}

          {/* Manage Announcement */}
          {admin && (
            <li className=" menu-item">
              <a className="menu-link menu-toggle">
                <i className="menu-icon tf-icons mdi mdi-bullhorn"></i>
                <div data-i18n="Manage Announcement">Manage Announcement</div>
              </a>
              <ul className="menu-sub">
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/addannouncement");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="Add Announcement">Add Announcement</div>
                  </a>
                </li>
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/viewannouncements");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="View Announcement">View Announcements</div>
                  </a>
                </li>
              </ul>
            </li>
          )}

          {/* Manage Events */}
          {/* <li className=" menu-item">
                <a className="menu-link menu-toggle">
                  <i className="menu-icon tf-icons mdi mdi-calendar"></i>
                  <div data-i18n="Manage Events">Manage Events</div>
                </a>
                <ul className="menu-sub">
                  <li className="cursor-pointer menu-item">
                    <a
                      onClick={() => {
                        navigate("/addevent");
                      }}
                      className="menu-link"
                    >
                      <div data-i18n="Add Event">Add Event</div>
                    </a>
                  </li>
                  <li className="cursor-pointer menu-item">
                    <a
                      onClick={() => {
                        navigate("/eventcalendar");
                      }}
                      className="menu-link"
                    >
                      <div data-i18n="Calendar">Calendar</div>
                    </a>
                  </li>
                </ul>
              </li> */}

          {/* Manage Abuse */}
          {admin && (
            <li className=" menu-item">
              <a className="menu-link menu-toggle">
                <i className="menu-icon tf-icons mdi mdi-alert"></i>
                <div data-i18n="Manage Abuse">Manage Abuse</div>
              </a>
              <ul className="menu-sub">
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/addviewabuse");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="Add / Show Abuse">Add / Show Abuse</div>
                  </a>
                </li>
              </ul>
            </li>
          )}

          {/* Manage Room */}
          {admin && (
            <li className=" menu-item">
              <a className="menu-link menu-toggle">
                <i className="menu-icon tf-icons mdi mdi-chair-school"></i>
                <div data-i18n="Manage Room">Manage Room</div>
              </a>
              <ul className="menu-sub">
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/addroom");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="Add Room">Add Room</div>
                  </a>
                </li>
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/viewrooms");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="View Rooms">View Rooms</div>
                  </a>
                </li>
              </ul>
            </li>
          )}

          {/* Manage Email Template */}
          {/* <li className=" menu-item">
                <a className="menu-link menu-toggle">
                  <i className="menu-icon tf-icons mdi mdi-email"></i>
                  <div data-i18n="Manage Email Template">
                    Manage Email Template
                  </div>
                </a>
                <ul className="menu-sub">
                  <li className="cursor-pointer menu-item">
                    <a
                      onClick={() => {
                        navigate("/addemailtemplate");
                      }}
                      className="menu-link"
                    >
                      <div data-i18n="Add Email Template">
                        Add Email Template
                      </div>
                    </a>
                  </li>
                  <li className="cursor-pointer menu-item">
                    <a
                      onClick={() => {
                        navigate("/viewemailtemplate");
                      }}
                      className="menu-link"
                    >
                      <div data-i18n="View Email Templates">
                        View Email Templates
                      </div>
                    </a>
                  </li>
                </ul>
              </li> */}

          {/* Manage Notification */}
          {admin && (
            <li className=" menu-item">
              <a className="menu-link menu-toggle">
                <i className="menu-icon tf-icons mdi mdi-bell-plus"></i>
                <div data-i18n="Manage Notification">Manage Notification</div>
              </a>
              <ul className="menu-sub">
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/addnotification");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="Add Notification">Add Notification</div>
                  </a>
                </li>
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/viewnotifications");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="View Notifications">View Notifications</div>
                  </a>
                </li>
              </ul>
            </li>
          )}

          {/* Manage packages */}
          {admin && (
            <li className=" menu-item">
              <a className="menu-link menu-toggle">
                <i className="menu-icon tf-icons mdi mdi-package-variant"></i>
                <div data-i18n="Manage Package">Manage Package</div>
              </a>
              <ul className="menu-sub">
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/addpackage");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="Add Package">Add Package</div>
                  </a>
                </li>
                <li className="cursor-pointer menu-item">
                  <a
                    onClick={() => {
                      navigate("/viewpackages");
                    }}
                    className="menu-link"
                  >
                    <div data-i18n="View Packages">View Packages</div>
                  </a>
                </li>
              </ul>
            </li>
          )}


          {/* Manage Certificate */}
          {/* <li className=" menu-item">
            <a className="menu-link menu-toggle">
              <i className="menu-icon tf-icons mdi mdi-certificate"></i>
              <div data-i18n="Certificate">Certificate</div>
            </a>
            <ul className="menu-sub">
              <li className="cursor-pointer menu-item">
                <a
                  onClick={() => {
                    navigate("/certificate1");
                  }}
                  className="menu-link"
                >
                  <div data-i18n="Certificate 1 ">Certificate 1 </div>
                </a>
              </li>
            
            </ul>
          </li> */}
        </ul>
      </aside>
    </>
  );
};

export default LeftSidebar;
